import { InformationItem as Item } from '../../types';

export const accountDetails: Item[] = [
  {
    title: 'Sign up date',
    value: 'Mar 10, 2024',
  },
  {
    title: 'Last activity date',
    value: 'May 08, 2025',
  },
  {
    title: 'Number of users',
    value: '2/3',
  },
  {
    title: 'API Key',
    value: 'Active',
  },
  {
    title: 'Account ID',
    value: 'ARK-100000',
  },
  {
    title: 'Internal account',
    isSwitch: true,
  },
];

export const getBillingSubscription = (isDowngraded: boolean): Item[] => [
  {
    title: 'Account type',
    value: isDowngraded ? 'Downgrade to free' : 'Subscribed',
  },
  {
    title: 'Subscription start date',
    value: 'Mar 10, 2025',
  },
  {
    title: isDowngraded
      ? 'Subscription expiry date'
      : 'Subscription renewal date',
    value: 'Mar 10, 2026',
  },
];

export const credits: Item[] = [
  {
    title: 'Total Credit Usage',
    value: '250,000',
  },
  {
    title: 'Credit balance',
    value: '500',
  },
  {
    title: 'Credit in plan',
    value: '9K',
  },
  {
    title: 'Credit Rollover',
    value: '9K',
  },
];
